import { Button } from '@nextui-org/react';
import React from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { FaFileUpload, FaTrash } from 'react-icons/fa';
import { formatarMedidaGenerico } from '../../../../util/mask';
import useDragDrop from './hooks/useDragDrop';

export interface DragDropProps {
  callback: () => Promise<void>;
}

const DragDrop = ({ callback }: DragDropProps): JSX.Element => {
  const { file, fileTypes, handleChange, handleSend, setFile, loading } =
    useDragDrop(callback);

  return (
    <div>
      <FileUploader
        handleChange={handleChange}
        name="file"
        types={fileTypes}
        multiple={false}
        disabled={loading || file != null}
        hoverTitle="solte aqui"
      >
        {file !== null ? (
          <div className="flex h-[64px] flex-row items-center gap-4 rounded border-2 border-dashed border-foreground-600 px-2">
            <Button
              type="button"
              color="danger"
              isIconOnly
              onPress={() => setFile(null)}
            >
              <FaTrash className="h-6 w-6 cursor-pointer" />
            </Button>

            <p className="text-sm text-foreground-700">
              {file.name} {formatarMedidaGenerico(file.size / 1000, 'Kb')}
            </p>

            <Button
              type="submit"
              isLoading={loading}
              isDisabled={file == null}
              onPress={() => handleSend()}
            >
              Adicionar
            </Button>
          </div>
        ) : (
          <div className="flex h-[64px] cursor-pointer flex-row items-center gap-4 rounded border-2 border-dashed border-foreground-500 px-4">
            <FaFileUpload className="h-6 w-6 text-foreground-700" />

            <p className="text-sm text-foreground-700">
              Clique ou solte aqui o arquivo para importar pedidos
            </p>
          </div>
        )}
      </FileUploader>
    </div>
  );
};

export default DragDrop;
